











import { Component, Prop, Vue } from 'vue-property-decorator';
import { AddNewModuleCard } from './components';

@Component({
  components: {
    AddNewModuleCard,
  },
})
export default class CardList extends Vue {
  @Prop({ type: Array, default: () => [] })
  readonly list!: Array<Object>;

  @Prop({ type: Boolean, default: false })
  readonly readonly!: boolean;

  removeEmitId(id: string) {
    this.$emit('removeEmitId', id);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/newprogram/components/cardlist/CardList.vue